// MisEventosPage.js - Eventos en que está inscrito el usuario (próximos y anteriores)
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import PageHero from './PageHero';
import InscripcionCard from './profile/InscripcionCard';
import { getMisInscripciones } from '../services/eventosService';
import { getS3ImageUrl } from '../services/s3Service';
import { getCachedImage } from '../utils/cmsCache';
import { parseFechaLocal } from '../utils/fechas';
import '../styles/profile/Profile.css';

const MisEventosPage = () => {
  const [items, setItems] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const [hero, setHero] = useState(() => getCachedImage('page_hero_profile'));

  useEffect(() => {
    getS3ImageUrl('page_hero_profile').then((u) => setHero(u || null)).catch(() => setHero(null));
    getMisInscripciones()
      .then(setItems)
      .catch((e) => setError(e.message || 'No se pudieron cargar tus eventos'))
      .finally(() => setCargando(false));
  }, []);

  const { proximos, anteriores } = useMemo(() => {
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    const fin = (i) => parseFechaLocal(i.evento?.fecha_fin || i.evento?.fecha_inicio);
    const prox = items.filter((i) => { const f = fin(i); return !f || f >= hoy; })
      .sort((a, b) => (parseFechaLocal(a.evento?.fecha_inicio) || 0) - (parseFechaLocal(b.evento?.fecha_inicio) || 0));
    const ant = items.filter((i) => { const f = fin(i); return f && f < hoy; });
    return { proximos: prox, anteriores: ant };
  }, [items]);

  return (
    <div className="main-container">
      <Header />
      <PageHero eyebrow="Mi perfil" imageUrl={hero} title="Mis eventos" subtitle="Las competencias en que estás inscrito y el estado de tu inscripción." />
      <main className="insc-page">
        <Link to="/profile" className="insc-volver">← Volver a mi perfil</Link>

        {cargando ? (
          <p className="insc-vacio">Cargando tus eventos…</p>
        ) : error ? (
          <p className="insc-vacio" style={{ color: '#c62828' }}>{error}</p>
        ) : items.length === 0 ? (
          <div className="insc-vacio">
            <p>Todavía no te has inscrito en ningún evento.</p>
            <Link to="/events" className="ach-pill ach-pill--red ach-pill--sm">Ver próximos eventos</Link>
          </div>
        ) : (
          <>
            <section>
              <h2 className="ach-display insc-seccion">Próximos</h2>
              {proximos.length === 0
                ? <p className="insc-vacio">No tienes inscripciones en eventos próximos.</p>
                : <div className="insc-lista">{proximos.map((i) => <InscripcionCard key={i.inscripcion_id} inscripcion={i} />)}</div>}
            </section>
            {anteriores.length > 0 && (
              <section>
                <h2 className="ach-display insc-seccion">Anteriores</h2>
                <div className="insc-lista">{anteriores.map((i) => <InscripcionCard key={i.inscripcion_id} inscripcion={i} />)}</div>
              </section>
            )}
          </>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default MisEventosPage;
